let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("hBh8x"), load("c6MKV"), load("f0OaY")]).then(() => parcelRequire('bkgW7'));